import { render, staticRenderFns } from "./SbRichText.vue?vue&type=template&id=47913884&"
import script from "./SbRichText.vue?vue&type=script&lang=js&"
export * from "./SbRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports